<div class="mx-auto w-full max-w-5xl px-4 py-8 sm:px-6 sm:py-10">
  <section class="overflow-hidden rounded-2xl border border-border bg-card p-5 shadow-sm sm:p-8">
    <div class="brand-gradient-bar -mx-5 -mt-5 mb-8 h-1.5 sm:-mx-8 sm:-mt-8"></div>
    <app-status-check-step />
  </section>
</div>
